import { cn } from '@commenda/utils';
import React from 'react';

import { Icons } from '../../Icons';
import { Tooltip } from '../../Tooltip';
import { TruncatedText } from '../../TruncatedText';
import { DataGridAlign, DataGridSemanticIntent } from '../types';
import { getDataGridJustifyClass } from '../utils';

export interface DataGridCellTextTooltipProps {
  children: React.ReactNode;
  intent?: DataGridSemanticIntent;
  tooltip?: React.ReactNode;
  leading?: React.ReactNode;
  align?: DataGridAlign;
  className?: string;
}

const DATA_GRID_CELL_TOOLTIP_ICONS: Record<
  DataGridSemanticIntent,
  React.ComponentType<{ className?: string }>
> = {
  neutral: Icons.InfoCircle,
  positive: Icons.CheckCircle,
  warning: Icons.AlertTriangle,
  critical: Icons.AlertCircle,
};

const DATA_GRID_CELL_TOOLTIP_ICON_CLASS_NAMES: Record<
  DataGridSemanticIntent,
  string
> = {
  neutral: '',
  positive: 'text-text-success',
  warning: 'text-text-warning',
  critical: 'text-text-error',
};

const DataGridCellTextTooltip = ({
  children,
  intent = 'neutral',
  tooltip,
  leading,
  align = 'left',
  className,
}: DataGridCellTextTooltipProps) => {
  const Glyph = DATA_GRID_CELL_TOOLTIP_ICONS[intent];
  const glyph = (
    <Glyph
      className={cn(
        'size-4 shrink-0',
        DATA_GRID_CELL_TOOLTIP_ICON_CLASS_NAMES[intent]
      )}
    />
  );

  return (
    <div
      className={cn(
        'flex w-full items-center gap-md',
        getDataGridJustifyClass(align),
        className
      )}
    >
      {leading}
      <TruncatedText className="txt-small-regular text-text-primary">
        {children}
      </TruncatedText>
      {tooltip ? (
        <Tooltip content={tooltip} asChild>
          <span className="flex shrink-0 items-center">{glyph}</span>
        </Tooltip>
      ) : (
        glyph
      )}
    </div>
  );
};

export { DataGridCellTextTooltip };
